import { BaseService } from "../../core/baseService";
import { ApiResult } from "../../core/types";
import {
  GuestDataServiceInterface,
  GuestListQuery,
  GuestListResponse,
  GuestDetail,
  GuestDataExport,
  UpdateGuestRequest,
} from "../types/guestData.types";

export class GuestDataService
  extends BaseService
  implements GuestDataServiceInterface
{
  private readonly basePath = "/api/admin/guests";

  async getGuests(
    params: GuestListQuery,
  ): Promise<ApiResult<GuestListResponse>> {
    const queryParams = this.buildQueryParams({
      search: params.search,
      page: params.page || 1,
      pageSize: params.pageSize || 25,
      inHouseOnly: params.inHouseOnly || undefined,
    });

    return this.handleRequest<GuestListResponse>(
      this.client.get(this.basePath, { params: queryParams }),
    );
  }

  async getGuestDetail(guestId: string): Promise<ApiResult<GuestDetail>> {
    return this.handleRequest<GuestDetail>(
      this.client.get(`${this.basePath}/${guestId}`),
    );
  }

  async exportGuestData(
    guestId: string,
  ): Promise<ApiResult<GuestDataExport>> {
    return this.handleRequest<GuestDataExport>(
      this.client.get(`${this.basePath}/${guestId}/export`),
    );
  }

  async anonymizeGuestData(
    guestId: string,
  ): Promise<ApiResult<{ success: boolean }>> {
    return this.handleRequest<{ success: boolean }>(
      this.client.post(`${this.basePath}/${guestId}/anonymize`),
    );
  }

  async updateGuest(
    guestId: string,
    data: UpdateGuestRequest,
  ): Promise<ApiResult<GuestDetail>> {
    return this.handleRequest<GuestDetail>(
      this.client.put(`${this.basePath}/${guestId}`, data),
    );
  }
}
